import React from 'react';
import { breakpoints } from '@sorted/sorted-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { processLogoutResponse } from '@sorted/pkce-oauth';
import MenuLink from '../MenuLink';
import colors from '../colors';
import environmentConfig from '../../../config';

const MenuLinkStyled = styled(MenuLink)`
	background-color: ${colors.dgray};

	@media (min-width: ${breakpoints.tablet}) {
		background-color: ${colors.navBg};
		padding-left: 20px;
	}

	&:hover svg {
		color: ${colors.pink};
	}

	svg {
		margin-right: 5px;
	}
`;

const Logout = ({ isOpen }) => {
	return (
		<MenuLinkStyled
			isOpen={isOpen}
			onClick={() => {
				processLogoutResponse();
				window.location = `${environmentConfig.authServer}/connect/endsession`;
			}}
		>
			<FontAwesomeIcon
				style={{ pointerEvents: 'none' }}
				fixedWidth
				size="lg"
				icon={faSignOut}
			/>
			{isOpen ? 'Logout' : ''}
		</MenuLinkStyled>
	);
};

export default Logout;
